const pricing = () => {
  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="section-title">
              <h2>Simple pricing for everyone</h2>
              <p>Whether you're looking for a full-time workspace or are just visiting, we've got an
                option for everyone
              </p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="pricing-wraper">
              <div className="pricing-item">
                <h3>Flexi Desk</h3>
                <span className="price">
                  <sup>&#x20B9;</sup>300/Day
                </span>
                <span className="price">
                  <sup>&#x20B9;</sup>5000/Month
                </span>
              </div>
              <a href="#enquiry" className="btn btn-primary scroll-to">Enquire Now</a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="pricing-wraper">
              <div className="pricing-item">
                <h3>Boss Cabin</h3>
                <span className="price">
                  <sup>&#x20B9;</sup>15000/Month
                </span>
                <span className="price">
                  <sup>&#x20B9;</sup>30000/Month
                </span>
              </div>
              <a href="#enquiry" className="btn btn-primary scroll-to">Enquire Now</a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="pricing-wraper">
              <div className="pricing-item">
              <h3>Meeting Room</h3>
                <span className="price">
                  <sup>&#x20B9;</sup>500/Hour
                </span>
                <span className="price">
                  <sup>&#x20B9;</sup>5000/Day
                </span>

              </div>
              <a href="#enquiry" className="btn btn-primary scroll-to">Enquire Now</a>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="pricing-wraper">
              <div className="pricing-item">
              <h3>Private Cabin</h3>
                <span className="price">
                  <sup>&#x20B9;</sup>6000/Month
                </span>
                <span className="price">
                <br/>
                </span>
                
              </div>
              <a href="#enquiry" className="btn btn-primary scroll-to">Enquire Now</a>
            </div>
          </div>
          <p style={{padding:'10px'}}><strong>*Additional 18% GST will be applicable on the above rates.</strong></p>
        </div>
      </div>
    </section>
  );
};
export default pricing;